<script setup lang="ts">
import IconSprite from '@/uiKit/IconSprite.vue'
import ToolTip from '@/uiKit/ToolTip.vue'
import AgentCover from './AgentCover.vue'

defineProps<{
  active: boolean
  description: string
  url: string | null
  id: string
  label: string
  selected: boolean
}>()
</script>

<template>
  <div
    :data-id="id"
    class="flex h-12 w-full min-w-0 shrink grow flex-row items-center gap-1.5 rounded-corner-8 p-1 pl-1.5"
  >
    <div class="flex size-5 shrink-0 flex-row items-center justify-center text-icon-subtlest">
      <IconSprite
        v-if="selected"
        icon="check"
        size="lg"
      />
    </div>
    <div class="size-5 shrink-0 text-icon-subtle">
      <slot name="icon">
        <AgentCover :url="url" />
      </slot>
    </div>
    <div class="flex h-10 max-w-80 min-w-10 shrink grow flex-col px-1.5 py-1">
      <span class="grow truncate text-sm-12px-default text-text">{{ label }}</span>
      <span
        v-if="description"
        class="truncate text-sm-12px-light text-text-subtle"
      >
        {{ description }}
      </span>
      <span
        v-else
        class="truncate text-sm-12px-light text-text-subtlest"
        >No description</span
      >
    </div>
  </div>
  <ToolTip
    :open="active"
    :title="label"
    :body="description"
    :auto-placement-options="{ allowedPlacements: ['right'] }"
    :target-selector="`[data-id='${id}']`"
  />
</template>
